import { useStore } from '@nanostores/react';
import { description } from './useChatHistory';

export function ChatDescription() {
  const storeDescription = useStore(description);
  const trimmed =
    storeDescription && storeDescription.length > 20 ? storeDescription.slice(0, 20) + '...' : storeDescription;
  return trimmed;
}
